import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<AboutPage data-id="element-6" />} data-id="element-5" />
          <Route path="/contact" element={<ContactPage data-id="element-8" />} data-id="element-7" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}